import { Trans, useTranslation } from 'react-i18next';
import SplashFeedback from 'utils/old-ui-commons/splash-feedback';

import { Flex, Text } from '@olist/united';

import { Container } from '../../../components/layout';
import { NotFound } from '../../../images';
import { ONBOARDING_FIRST_STEPS_URL } from '../../../utils/urls';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Flex flexDirection="column" mt="15%">
        <SplashFeedback
          imgSrc={NotFound}
          title={
            <Text.H3 color="foundation.primaryDefault" fontWeight="bold">
              {t`Oops! Page not found`}
            </Text.H3>
          }
          subtitle={
            <Text color="foundation.shadeDark">
              <Trans i18nKey="Make sure the address you are looking for is correct or return to the <2>start page</2>">
                Make sure the address you are looking for is correct or return to the{' '}
                <Text.Link href={ONBOARDING_FIRST_STEPS_URL}>start page</Text.Link>
              </Trans>
            </Text>
          }
        />
      </Flex>
    </Container>
  );
};

export default NotFoundPage;
